import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=08efbe56&scoped=true&"
import script from "./UserNew.vue?vue&type=script&lang=js&"
export * from "./UserNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efbe56",
  null
  
)

export default component.exports